import { create } from 'zustand'
import type { User, Tenant } from '@/types/database'
import type { Session } from '@supabase/supabase-js'

interface AuthState {
    session: Session | null
    user: User | null
    tenant: Tenant | null
    isLoading: boolean
    isAuthenticated: boolean

    setSession: (session: Session | null) => void
    setUser: (user: User | null) => void
    setTenant: (tenant: Tenant | null) => void
    setLoading: (isLoading: boolean) => void
    logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
    session: null,
    user: null,
    tenant: null,
    isLoading: true,
    isAuthenticated: false,

    setSession: (session) =>
        set({ session, isAuthenticated: !!session }),

    setUser: (user) => set({ user }),

    setTenant: (tenant) => set({ tenant }),

    setLoading: (isLoading) => set({ isLoading }),

    logout: () =>
        set({
            session: null,
            user: null,
            tenant: null,
            isAuthenticated: false,
        }),
}))
